export const config = {
  apiUrl: process.env.REACT_APP_CLIENT_API_URL,
  s3BucketUrl: process.env.REACT_APP_CLIENT_S3_BUCKET_URL,
  assetUrl: process.env.REACT_APP_CLIENT_ASSET_URL,
  cdnUrl: process.env.REACT_APP_CLIENT_CDN_URL,
  altImg: 'images/no_avatar_profile.jpg',
  baseUrl: process.env.REACT_APP_CLIENT_MAIN_URL + '/',
  altInvImg: 'images/inv_img.jpeg',
  mainUrl: process.env.REACT_APP_CLIENT_MAIN_URL,
  pusherKey: process.env.REACT_APP_CLIENT_PUSHER_KEY,
  pusherCluster: process.env.REACT_APP_CLIENT_PUSHER_CLUSTER,
  dsn: process.env.REACT_APP_CLIENT_DSN,
  navBgColor: process.env.REACT_APP_CLIENT_NAV_BG_COLOR,
};

/**
 * Get the proper image URL - handles both CDN and local paths
 * @param {string} path - The image path
 * @param {string} defaultImg - Default image if path is empty
 * @returns {string} The full image URL
 */
export const getImageUrl = (path, defaultImg = config.altImg) => {
  if (!path) {
    return `${config.apiUrl}/${defaultImg}`;
  }
  // If path already starts with http, return as-is (full CDN URL from backend)
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // If CDN URL is configured and path looks like a DO Spaces path
  if (
    config.cdnUrl &&
    (path.includes('dev_') ||
      path.includes('live_') ||
      path.includes('profilepic') ||
      path.includes('resourcepic'))
  ) {
    return `${config.cdnUrl}/${path}`;
  }
  // Fallback to API URL
  return `${config.apiUrl}/${path}`;
};
